import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import { formatIQD } from '../../../shared/format.js';

function normalize(data) {
  const arr = Array.isArray(data) ? data : data?.trend || data?.daily || data?.series || data?.data || [];
  return arr.map((d, i) => ({
    date: d.date ?? d.day ?? d.label ?? `يوم ${i + 1}`,
    revenue: Number(d.revenue ?? d.income ?? 0),
    expense: Number(d.expense ?? d.expenses ?? 0)
  }));
}

function formatYAxis(v) {
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}م`;
  if (v >= 1_000) return `${Math.round(v / 1_000)}ك`;
  return v;
}

export function FinancialSummaryChart({ data, height = 280 }) {
  const rows = normalize(data);
  const empty = !rows.length || rows.every((r) => !r.revenue && !r.expense);

  return (
    <div className="relative" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={rows} margin={{ top: 10, right: 8, left: 8, bottom: 4 }}>
          <defs>
            <linearGradient id="rev" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FF7A1A" stopOpacity={0.45} />
              <stop offset="100%" stopColor="#FF7A1A" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="exp" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#EF4444" stopOpacity={0.4} />
              <stop offset="100%" stopColor="#EF4444" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#F0E6DA" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 10, fill: '#9CA3AF' }} tickLine={false} axisLine={false} />
          <YAxis
            tick={{ fontSize: 10, fill: '#9CA3AF' }}
            tickLine={false}
            axisLine={false}
            tickFormatter={formatYAxis}
            width={42}
          />
          <Tooltip
            formatter={(v) => formatIQD(v)}
            contentStyle={{ background: '#fff', border: '1px solid #EFE7D6', borderRadius: 10, fontSize: 12 }}
          />
          <Legend wrapperStyle={{ fontSize: 11.5, paddingTop: 6 }} iconType="circle" iconSize={8} />
          <Area type="monotone" dataKey="revenue" name="الإيراد" stroke="#FF7A1A" fill="url(#rev)" strokeWidth={2} />
          <Area type="monotone" dataKey="expense" name="المصاريف" stroke="#EF4444" fill="url(#exp)" strokeWidth={2} />
        </AreaChart>
      </ResponsiveContainer>
      {empty ? (
        <div className="absolute inset-0 grid place-items-center text-ink-3 text-xs pointer-events-none">
          لا توجد بيانات بعد
        </div>
      ) : null}
    </div>
  );
}
